import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import CancelIcon from "../../../assets/icons/cancel icon-01.svg";
import menuIcon from "../../../assets/icons/menu.svg";
const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <>
      {showSidebar ? (
        <button
          className="flex text-[12px] items-center cursor-pointer fixed left-10 top-3 z-50"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <img
            className=" w-4 h-4  ml-6 my-2 screen800:my-1 screen800:ml-0  screen500:my-0 screen800:w-3 screen500:w-2 screen1800:w-7 screen1800:h-7"
            width={16}
            height={16}
            src={CancelIcon}
            alt="بستن"
          />
        </button>
      ) : (
        <img
          alt="منو آیکن"
          onClick={() => setShowSidebar(!showSidebar)}
          className="absolute z-30  items-center cursor-pointer left-35 top-4 w-10 h-10 
          screen500:w-6 screen500:h-6  screen1000:w-8 screen1000:h-8 screen1800:w-14 screen1800:h-14"
          src={menuIcon}
        />
      )}

      <div
        className={`top-0 left-0 w-full h-16 bg-[#6d6e70]  pl-10 fixed z-40 screen800:h-14 screen500:h-10  screen1800:h-20 ${
          showSidebar
            ? "transition duration-1000 ease-in-out -translate-y-0 "
            : "transition duration-1000 ease-in-out -translate-y-full"
        }`}
      >
        <ul
          className="flex flex-row-reverse justify-center  py-3 text-[16px] text-white  duration-700 font-bold screen800:text-[14px] screen500:text-[11px] screen1800:text-[23px]
        "
        >
          <NavLink onClick={() => setShowSidebar(!showSidebar)}
            className={({ isActive }) => (isActive ? "text-[#f5911e] " : "")}
            to="/"
          >
            <li className="">خانه</li>
          </NavLink>
          <NavLink onClick={() => setShowSidebar(!showSidebar)}
            className={({ isActive }) => (isActive ? "text-[#f5911e] " : "")}
            to="/contact-us"
          >
            <li className="px-24 screen800:px-12  screen500:px-8 screen1800:px-40 ">
              ارتباط با ما
            </li>
          </NavLink>
          <NavLink onClick={() => setShowSidebar(!showSidebar)}
            className={({ isActive }) => (isActive ? "text-[#f5911e] " : "")}
            to="/about-us"
          >
            <li className="">درباره ی ما</li>
          </NavLink>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
